import React from 'react';
import EventMg from '../utilities/EventManager';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';

/**
 * 会社のBOXで"新規登録"の選択時
 * src/components/FieldTreeCompany.jsxのHoverMenuDefaultコンポーネント
 * "登録データを検索して追加" or "会社情報を代理入力して追加"を出すためのダイアログ
 *
 * @export
 * @class FieldTreeNewBlock
 * @extends {React.Component}
 */
export default class FieldTreeNewBlock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lineHeight: 0,
      top: 0,
      hover: false,
      proxy: false,
    };
  }

  componentDidMount() {
    EventMg.trigger(FIELD_TREE_EVENTS.TREE_NEWMENU_REF, this.newMenuRef);
    // 元請BOXから「新規登録」を押した場合、代理入力は必ず可能
    if (this.props.constructor === true) {
      this.setState({
        proxy: true,
      });
    } else {
      // 協力会社BOXから「新規登録」を押した場合、permissionsで代理入力ボタンの有無をチェックする
      if (this.props.nodes.permissions.company.new === true) {
        this.setState({
          proxy: true,
        });
      }
    }
  }

  componentWillUnmount() {
    EventMg.trigger(FIELD_TREE_EVENTS.TREE_NEWMENU_REF, null);
  }

  /**
   * 新規作成時に青い縦棒を生成
   *
   * @memberof FieldTreeNewBlock
   */

  render() {
    return (
      <div
        className='fieldstree-new-menu'
        id={`path-${this.props.path}`}
        ref={e => {
          this.newMenuRef = e;
        }}
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {this.props.nodes.permissions.partner_box.search_and_add && (
          <div
            className='fieldstree-new-menu__item'
            onClick={() => {
              EventMg.trigger(
                FIELD_TREE_EVENTS.NEW_BY_SEARCH,
                this.props.path,
                this.props.nodes
              );
            }}
          >
            登録済み協力会社から追加
          </div>
        )}
        {this.props.nodes.permissions.partner_box.proxy_register && (
          <div
            className='fieldstree-new-menu__item'
            onClick={() => {
              EventMg.trigger(
                FIELD_TREE_EVENTS.NEW_BY_FORM,
                this.props.path,
                this.props.nodes
              );
            }}
          >
            会社情報を新規登録して追加
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldTreeNewBlock.jsx